import styled from '@emotion/styled';

export const SpacingContainer = styled.div`
  padding: 20px;
`;
